export default __webpack_public_path__ + "static/media/MVP Ecosystems.16c18d01.png";